export default __webpack_public_path__ + "static/media/card_info_blue_background.05c3cae4.svg";